import { render, staticRenderFns } from "./ToExpireProductsBlock.vue?vue&type=template&id=c2cf7db4&scoped=true&"
import script from "./ToExpireProductsBlock.vue?vue&type=script&lang=ts&"
export * from "./ToExpireProductsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cf7db4",
  null
  
)

export default component.exports